// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `span.MuiCheckbox-colorSecondary.Mui-checked{color:#005f91}`, "",{"version":3,"sources":["webpack://./src/components/Controls/CustomCheckbox/styles.scss"],"names":[],"mappings":"AAEA,4CACE,aAAA","sourcesContent":["@import \"assets/styles/_variables\";\n\nspan.MuiCheckbox-colorSecondary.Mui-checked {\n  color: $blue;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
